import { createContext } from "react";

export interface FavoriteReportsContextValue {
  isFavorite(id: string): boolean;
  setIsFavorite(id: string, favorite: boolean): void;
  favorites: string[];
}

export const FavoriteReportsContext = createContext<FavoriteReportsContextValue>({ isFavorite: () => false, setIsFavorite: () => { /* empty */ }, favorites: [] });
